import constate from 'constate';
import { useState } from 'react';

export const [DonationCardsProvider, useDonationCards] = constate(() => {
  const [maximumPhotosUploadCountReached, setMaximumPhotosUploadCountReached] = useState(false);

  return {
    maximumPhotosUploadCountReached,
    setMaximumPhotosUploadCountReached,
  };
});
